import Vue from 'vue'
import messagePopup from './messagePopup.vue'

const ToastConstructor = Vue.extend(messagePopup)

let instance
const instances = []

const MessagePopup = function (options) {
    options = options || {}
    if (typeof options === 'string') {
        options = {
            message: options
        }
    }
    instance = new ToastConstructor({
        data: options
    })
    // instance.id = id;
    instance.$slots.default = [instance.message]
    if (!instance.message) {
        return false
    }
    instance.message = null
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)

    instance.vm.visible = true
    instance.dom = instance.vm.$el
    instances.push(instance)
    return instance.vm
}

Vue.prototype.$messagePopup = MessagePopup

export default MessagePopup



// WEBPACK FOOTER //
// ./src/components/MessagePopup/index.js